import { createFileRoute } from '@tanstack/react-router';
import { MuiLicenseTest } from '../../features/mui-license-test/mui-license-test';

export const Route = createFileRoute('/_auth/mui-license-test')({
  staticData: {
    title: 'MUI X Premium License Test',
    description: 'Test MUI X Premium license functionality',
  },
  component: MuiLicenseTest,
});
